<template>
  <div class="dataProcessing">
    <iframe class="iframe_div" :src="url" v-if="url"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
      addUrl: "",
      showCreate: false,
    };
  },
  methods: {
    init() {
      this.url = IOT_CONFIG.paths["dataProcessing"];
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang='less'>
.dataProcessing {
  position: relative;
  .create_btn {
    position: absolute;
    top: 116px;
    right: 60px;
  }
}
</style>